module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-link/~/babel-runtime/core-js/object/keys.js
// module id = ./node_modules/gatsby-link/node_modules/babel-runtime/core-js/object/keys.js
// module chunks = 168707334958949